export enum PointsCurrency {
  PTS = 'PTS',
}
